module.exports = __webpack_public_path__ + "static/media/upload-video-icon.ad909600.svg";